import { render, staticRenderFns } from "./ViewProof.vue?vue&type=template&id=30b5826a&scoped=true&"
import script from "./ViewProof.vue?vue&type=script&lang=js&"
export * from "./ViewProof.vue?vue&type=script&lang=js&"
import style0 from "./ViewProof.vue?vue&type=style&index=0&id=30b5826a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b5826a",
  null
  
)

export default component.exports